

import React, { useState } from 'react';
import { Calendar } from "primereact/calendar";

const ClosableCalendar = (props) => {
    const [visible, setVisible] = useState(false);

    const visibilityChange = (e) => {
        if(e.type === "outside") {
            setVisible(false)
        }
        else {
            setVisible(true)
        }
    }

    return (
        <Calendar {...props} visible={visible} onVisibleChange={visibilityChange}></Calendar>
    )
}

export default ClosableCalendar;